var _use, _use2, _use3, _use4, _use5, _use6, _use7, _use8, _use9, _use10, _use11, _use12, _use13, _use14, _use15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "97pt",
    height: "71pt",
    viewBox: "0 0 97 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.296875 -4.484375 L 4.375 -6.65625 C 4.34375 -6.734375 4.3125 -6.78125 4.3125 -6.796875 C 4.3125 -6.859375 4.5 -7.0625 4.96875 -7.109375 C 5.078125 -7.125 5.1875 -7.125 5.1875 -7.3125 C 5.1875 -7.453125 5.046875 -7.453125 5.015625 -7.453125 C 4.5625 -7.453125 4.09375 -7.421875 3.640625 -7.421875 C 3.375 -7.421875 2.6875 -7.453125 2.421875 -7.453125 C 2.359375 -7.453125 2.21875 -7.453125 2.21875 -7.234375 C 2.21875 -7.109375 2.328125 -7.109375 2.46875 -7.109375 C 3.125 -7.109375 3.203125 -7 3.296875 -6.765625 L 4.578125 -3.71875 L 2.28125 -1.25 L 2.140625 -1.125 C 1.609375 -0.546875 1.09375 -0.375 0.53125 -0.34375 C 0.390625 -0.328125 0.296875 -0.328125 0.296875 -0.125 C 0.296875 -0.109375 0.296875 0 0.4375 0 C 0.765625 0 1.125 -0.03125 1.46875 -0.03125 C 1.859375 -0.03125 2.296875 0 2.6875 0 C 2.75 0 2.875 0 2.875 -0.21875 C 2.875 -0.328125 2.765625 -0.34375 2.75 -0.34375 C 2.65625 -0.34375 2.3125 -0.375 2.3125 -0.671875 C 2.3125 -0.84375 2.46875 -1.03125 2.609375 -1.171875 L 3.71875 -2.34375 L 4.703125 -3.40625 L 5.796875 -0.8125 C 5.84375 -0.6875 5.859375 -0.671875 5.859375 -0.65625 C 5.859375 -0.5625 5.65625 -0.375 5.21875 -0.34375 C 5.109375 -0.328125 5 -0.3125 5 -0.125 C 5 0 5.125 0 5.171875 0 C 5.46875 0 6.234375 -0.03125 6.546875 -0.03125 C 6.8125 -0.03125 7.484375 0 7.75 0 C 7.828125 0 7.96875 0 7.96875 -0.203125 C 7.96875 -0.34375 7.859375 -0.34375 7.765625 -0.34375 C 7.03125 -0.34375 7.015625 -0.375 6.828125 -0.8125 C 6.40625 -1.828125 5.671875 -3.53125 5.421875 -4.1875 C 6.15625 -4.953125 7.3125 -6.25 7.65625 -6.546875 C 7.96875 -6.8125 8.390625 -7.078125 9.046875 -7.109375 C 9.1875 -7.125 9.28125 -7.125 9.28125 -7.328125 C 9.28125 -7.34375 9.28125 -7.453125 9.140625 -7.453125 C 8.8125 -7.453125 8.453125 -7.421875 8.109375 -7.421875 C 7.703125 -7.421875 7.296875 -7.453125 6.90625 -7.453125 C 6.84375 -7.453125 6.703125 -7.453125 6.703125 -7.234375 C 6.703125 -7.15625 6.75 -7.125 6.828125 -7.109375 C 6.921875 -7.09375 7.265625 -7.078125 7.265625 -6.765625 C 7.265625 -6.625 7.140625 -6.484375 7.0625 -6.375 Z M 5.296875 -4.484375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 6.515625 -6.203125 L 6.65625 -6.359375 C 6.984375 -6.6875 7.34375 -7.0625 8.09375 -7.109375 C 8.21875 -7.125 8.3125 -7.125 8.3125 -7.3125 C 8.3125 -7.40625 8.25 -7.453125 8.171875 -7.453125 C 7.890625 -7.453125 7.5625 -7.421875 7.28125 -7.421875 C 6.921875 -7.421875 6.53125 -7.453125 6.1875 -7.453125 C 6.125 -7.453125 5.984375 -7.453125 5.984375 -7.234375 C 5.984375 -7.125 6.078125 -7.109375 6.140625 -7.109375 C 6.21875 -7.109375 6.53125 -7.09375 6.53125 -6.859375 C 6.53125 -6.671875 6.28125 -6.390625 6.234375 -6.34375 L 3.703125 -3.421875 L 2.515625 -6.65625 C 2.4375 -6.8125 2.4375 -6.84375 2.4375 -6.84375 C 2.4375 -7.109375 2.984375 -7.109375 3.09375 -7.109375 C 3.234375 -7.109375 3.34375 -7.109375 3.34375 -7.328125 C 3.34375 -7.453125 3.21875 -7.453125 3.1875 -7.453125 C 2.875 -7.453125 2.109375 -7.421875 1.8125 -7.421875 C 1.53125 -7.421875 0.859375 -7.453125 0.59375 -7.453125 C 0.53125 -7.453125 0.375 -7.453125 0.375 -7.234375 C 0.375 -7.109375 0.484375 -7.109375 0.625 -7.109375 C 1.28125 -7.109375 1.328125 -7.015625 1.421875 -6.734375 L 2.765625 -3.15625 C 2.78125 -3.125 2.8125 -3 2.8125 -2.96875 C 2.8125 -2.9375 2.375 -1.171875 2.328125 -0.984375 C 2.1875 -0.375 2.171875 -0.34375 1.296875 -0.34375 C 1.09375 -0.34375 1 -0.34375 1 -0.125 C 1 0 1.140625 0 1.15625 0 C 1.46875 0 2.21875 -0.03125 2.53125 -0.03125 C 2.828125 -0.03125 3.625 0 3.921875 0 C 4 0 4.140625 0 4.140625 -0.21875 C 4.140625 -0.34375 4.03125 -0.34375 3.828125 -0.34375 C 3.8125 -0.34375 3.59375 -0.34375 3.40625 -0.359375 C 3.1875 -0.375 3.125 -0.40625 3.125 -0.53125 C 3.125 -0.609375 3.21875 -1 3.265625 -1.21875 L 3.65625 -2.765625 C 3.703125 -2.96875 3.71875 -3 3.8125 -3.09375 Z M 6.515625 -6.203125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-3"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.25 -7.28125 C 5.265625 -7.328125 5.296875 -7.390625 5.296875 -7.453125 C 5.296875 -7.5625 5.21875 -7.5625 5.15625 -7.5625 C 5.046875 -7.5625 5.03125 -7.546875 5 -7.34375 L 3.1875 -0.140625 C 2.359375 -0.234375 1.9375 -0.640625 1.9375 -1.359375 C 1.9375 -1.578125 1.9375 -1.859375 2.53125 -3.390625 C 2.578125 -3.515625 2.65625 -3.703125 2.65625 -3.921875 C 2.65625 -4.421875 2.296875 -4.828125 1.75 -4.828125 C 0.71875 -4.828125 0.3125 -3.234375 0.3125 -3.140625 C 0.3125 -3.03125 0.421875 -3.03125 0.453125 -3.03125 C 0.5625 -3.03125 0.5625 -3.046875 0.625 -3.234375 C 0.921875 -4.265625 1.359375 -4.578125 1.71875 -4.578125 C 1.8125 -4.578125 2 -4.578125 2 -4.234375 C 2 -3.953125 1.890625 -3.671875 1.75 -3.296875 C 1.21875 -1.921875 1.21875 -1.640625 1.21875 -1.453125 C 1.21875 -0.421875 2.078125 0.03125 3.125 0.09375 C 3.03125 0.484375 3.03125 0.515625 2.875 1.09375 C 2.84375 1.203125 2.625 2.09375 2.625 2.125 C 2.625 2.140625 2.625 2.234375 2.765625 2.234375 C 2.78125 2.234375 2.828125 2.234375 2.859375 2.1875 C 2.890625 2.171875 2.953125 1.890625 2.984375 1.75 L 3.40625 0.125 C 3.8125 0.125 4.765625 0.125 5.796875 -1.046875 C 6.234375 -1.546875 6.46875 -2.03125 6.59375 -2.359375 C 6.6875 -2.625 6.921875 -3.578125 6.921875 -4.0625 C 6.921875 -4.671875 6.625 -4.828125 6.453125 -4.828125 C 6.171875 -4.828125 5.90625 -4.53125 5.90625 -4.296875 C 5.90625 -4.15625 5.96875 -4.09375 6.0625 -4 C 6.1875 -3.875 6.453125 -3.59375 6.453125 -3.078125 C 6.453125 -2.375 5.890625 -1.484375 5.5 -1.09375 C 4.546875 -0.125 3.84375 -0.125 3.453125 -0.125 Z M 5.25 -7.28125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph0-4"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 1.859375 1.859375 C 1.8125 2 1.796875 2.015625 1.796875 2.078125 C 1.796875 2.3125 2 2.375 2.109375 2.375 C 2.171875 2.375 2.40625 2.34375 2.515625 2.09375 C 2.546875 2 2.609375 1.640625 2.90625 0.09375 C 3 0.109375 3.078125 0.125 3.265625 0.125 C 5.078125 0.125 6.75 -1.59375 6.75 -3.3125 C 6.75 -4.171875 6.328125 -4.828125 5.5 -4.828125 C 3.921875 -4.828125 3.265625 -2.703125 2.625 -0.578125 C 1.4375 -0.796875 0.828125 -1.40625 0.828125 -2.1875 C 0.828125 -2.5 1.078125 -3.703125 1.734375 -4.453125 C 1.828125 -4.546875 1.828125 -4.5625 1.828125 -4.59375 C 1.828125 -4.640625 1.796875 -4.703125 1.6875 -4.703125 C 1.390625 -4.703125 0.546875 -3.125 0.546875 -2.078125 C 0.546875 -1.046875 1.265625 -0.25 2.4375 0.015625 Z M 3.359375 -0.515625 C 3.265625 -0.515625 3.25 -0.515625 3.15625 -0.53125 C 3.03125 -0.53125 3.015625 -0.53125 3.015625 -0.5625 C 3.015625 -0.59375 3.203125 -1.578125 3.234375 -1.75 C 3.578125 -3.140625 4.421875 -4.1875 5.40625 -4.1875 C 6.15625 -4.1875 6.453125 -3.59375 6.453125 -3.078125 C 6.453125 -1.84375 5.03125 -0.515625 3.359375 -0.515625 Z M 3.359375 -0.515625 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph1-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.921875 -3.421875 L 3.3125 -3.421875 L 4.953125 -0.890625 C 5.0625 -0.71875 5.328125 -0.296875 5.4375 -0.125 C 5.515625 0 5.546875 0 5.796875 0 L 7.3125 0 C 7.5 0 7.671875 0 7.671875 -0.203125 C 7.671875 -0.28125 7.609375 -0.359375 7.5 -0.375 C 7.09375 -0.46875 6.5625 -1.1875 6.296875 -1.53125 C 6.234375 -1.640625 5.6875 -2.359375 4.953125 -3.546875 C 5.921875 -3.71875 6.859375 -4.140625 6.859375 -5.4375 C 6.859375 -6.953125 5.25 -7.46875 3.96875 -7.46875 L 0.546875 -7.46875 C 0.34375 -7.46875 0.171875 -7.46875 0.171875 -7.28125 C 0.171875 -7.09375 0.375 -7.09375 0.46875 -7.09375 C 1.09375 -7.09375 1.140625 -7.015625 1.140625 -6.46875 L 1.140625 -1 C 1.140625 -0.453125 1.09375 -0.375 0.46875 -0.375 C 0.375 -0.375 0.171875 -0.375 0.171875 -0.203125 C 0.171875 0 0.34375 0 0.546875 0 L 3.53125 0 C 3.734375 0 3.890625 0 3.890625 -0.203125 C 3.890625 -0.375 3.703125 -0.375 3.59375 -0.375 C 2.96875 -0.375 2.921875 -0.46875 2.921875 -1 Z M 5.03125 -3.953125 C 5.328125 -4.359375 5.359375 -4.9375 5.359375 -5.421875 C 5.359375 -5.9375 5.296875 -6.515625 4.953125 -6.96875 C 5.40625 -6.875 6.484375 -6.53125 6.484375 -5.4375 C 6.484375 -4.71875 6.15625 -4.171875 5.03125 -3.953125 Z M 2.921875 -6.5 C 2.921875 -6.734375 2.921875 -7.09375 3.59375 -7.09375 C 4.53125 -7.09375 4.984375 -6.703125 4.984375 -5.421875 C 4.984375 -4.015625 4.640625 -3.8125 2.921875 -3.8125 Z M 1.4375 -0.375 C 1.53125 -0.578125 1.53125 -0.890625 1.53125 -0.984375 L 1.53125 -6.484375 C 1.53125 -6.59375 1.53125 -6.890625 1.4375 -7.09375 L 2.6875 -7.09375 C 2.546875 -6.921875 2.546875 -6.703125 2.546875 -6.53125 L 2.546875 -0.984375 C 2.546875 -0.875 2.546875 -0.578125 2.625 -0.375 Z M 3.765625 -3.421875 C 3.84375 -3.4375 3.875 -3.453125 3.96875 -3.453125 C 4.140625 -3.453125 4.375 -3.46875 4.53125 -3.484375 C 4.703125 -3.234375 5.875 -1.28125 6.78125 -0.375 L 5.71875 -0.375 Z M 3.765625 -3.421875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph2-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.328125 -5.296875 C 2.328125 -5.3125 2.359375 -5.40625 2.359375 -5.421875 C 2.359375 -5.453125 2.328125 -5.53125 2.234375 -5.53125 C 2.203125 -5.53125 1.953125 -5.5 1.765625 -5.484375 L 1.328125 -5.453125 C 1.140625 -5.4375 1.0625 -5.4375 1.0625 -5.296875 C 1.0625 -5.171875 1.171875 -5.171875 1.28125 -5.171875 C 1.65625 -5.171875 1.65625 -5.125 1.65625 -5.0625 C 1.65625 -5.03125 1.65625 -5.015625 1.625 -4.875 L 0.484375 -0.34375 C 0.453125 -0.21875 0.453125 -0.171875 0.453125 -0.171875 C 0.453125 -0.03125 0.5625 0.078125 0.71875 0.078125 C 0.984375 0.078125 1.046875 -0.171875 1.078125 -0.28125 C 1.15625 -0.625 1.375 -1.46875 1.453125 -1.796875 C 1.890625 -1.75 2.4375 -1.609375 2.4375 -1.140625 C 2.4375 -1.109375 2.4375 -1.0625 2.421875 -0.984375 C 2.390625 -0.890625 2.375 -0.765625 2.375 -0.734375 C 2.375 -0.265625 2.71875 0.078125 3.1875 0.078125 C 3.515625 0.078125 3.734375 -0.171875 3.828125 -0.3125 C 4.03125 -0.609375 4.15625 -1.09375 4.15625 -1.140625 C 4.15625 -1.21875 4.09375 -1.25 4.03125 -1.25 C 3.9375 -1.25 3.921875 -1.1875 3.890625 -1.046875 C 3.78125 -0.671875 3.578125 -0.140625 3.203125 -0.140625 C 3 -0.140625 2.953125 -0.3125 2.953125 -0.53125 C 2.953125 -0.640625 2.953125 -0.734375 3 -0.921875 C 3 -0.953125 3.03125 -1.078125 3.03125 -1.15625 C 3.03125 -1.8125 2.21875 -1.953125 1.8125 -2.015625 C 2.109375 -2.1875 2.375 -2.46875 2.46875 -2.5625 C 2.90625 -3 3.265625 -3.296875 3.65625 -3.296875 C 3.75 -3.296875 3.84375 -3.265625 3.90625 -3.1875 C 3.484375 -3.125 3.484375 -2.75 3.484375 -2.75 C 3.484375 -2.578125 3.625 -2.453125 3.796875 -2.453125 C 4.015625 -2.453125 4.25 -2.625 4.25 -2.953125 C 4.25 -3.234375 4.0625 -3.515625 3.65625 -3.515625 C 3.203125 -3.515625 2.78125 -3.15625 2.328125 -2.703125 C 1.859375 -2.25 1.671875 -2.171875 1.53125 -2.109375 Z M 2.328125 -5.296875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph3-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.84375 -2.71875 C 4.84375 -3.890625 3.875 -4.84375 2.71875 -4.84375 C 1.546875 -4.84375 0.59375 -3.875 0.59375 -2.71875 C 0.59375 -1.578125 1.546875 -0.609375 2.71875 -0.609375 C 3.875 -0.609375 4.84375 -1.5625 4.84375 -2.71875 Z M 2.71875 -1.046875 C 1.78125 -1.046875 1.03125 -1.8125 1.03125 -2.71875 C 1.03125 -3.640625 1.78125 -4.40625 2.71875 -4.40625 C 3.625 -4.40625 4.40625 -3.671875 4.40625 -2.71875 C 4.40625 -1.78125 3.625 -1.046875 2.71875 -1.046875 Z M 2.71875 -1.046875 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph4-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 5.5625 -1.8125 C 5.703125 -1.8125 5.875 -1.8125 5.875 -1.984375 C 5.875 -2.171875 5.703125 -2.171875 5.5625 -2.171875 L 1 -2.171875 C 0.875 -2.171875 0.703125 -2.171875 0.703125 -1.984375 C 0.703125 -1.8125 0.875 -1.8125 1 -1.8125 Z M 5.5625 -1.8125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph5-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.5 -5.078125 C 2.5 -5.296875 2.484375 -5.296875 2.265625 -5.296875 C 1.9375 -4.984375 1.515625 -4.796875 0.765625 -4.796875 L 0.765625 -4.53125 C 0.984375 -4.53125 1.40625 -4.53125 1.875 -4.734375 L 1.875 -0.65625 C 1.875 -0.359375 1.84375 -0.265625 1.09375 -0.265625 L 0.8125 -0.265625 L 0.8125 0 C 1.140625 -0.03125 1.828125 -0.03125 2.1875 -0.03125 C 2.546875 -0.03125 3.234375 -0.03125 3.5625 0 L 3.5625 -0.265625 L 3.28125 -0.265625 C 2.53125 -0.265625 2.5 -0.359375 2.5 -0.65625 Z M 2.5 -5.078125 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-0"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: ""
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 2.453125 -6.59375 C 2.453125 -6.984375 2.484375 -7.109375 3.34375 -7.109375 L 3.625 -7.109375 L 3.625 -7.453125 C 3.25 -7.421875 2.390625 -7.421875 1.96875 -7.421875 C 1.546875 -7.421875 0.6875 -7.421875 0.3125 -7.453125 L 0.3125 -7.109375 L 0.59375 -7.109375 C 1.453125 -7.109375 1.484375 -6.984375 1.484375 -6.59375 L 1.484375 -0.84375 C 1.484375 -0.453125 1.453125 -0.34375 0.59375 -0.34375 L 0.3125 -0.34375 L 0.3125 0 C 0.6875 -0.03125 1.546875 -0.03125 1.96875 -0.03125 C 2.390625 -0.03125 3.25 -0.03125 3.625 0 L 3.625 -0.34375 L 3.34375 -0.34375 C 2.484375 -0.34375 2.453125 -0.453125 2.453125 -0.84375 Z M 2.453125 -6.59375 "
  })), /*#__PURE__*/React.createElement("symbol", {
    overflow: "visible",
    id: "glyph6-2"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none"
    },
    d: "M 4.140625 -0.59375 L 4.140625 0.125 L 5.75 0 L 5.75 -0.34375 C 4.984375 -0.34375 4.890625 -0.421875 4.890625 -0.953125 L 4.890625 -7.5625 L 3.328125 -7.453125 L 3.328125 -7.109375 C 4.09375 -7.109375 4.171875 -7.03125 4.171875 -6.5 L 4.171875 -4.140625 C 3.859375 -4.53125 3.390625 -4.828125 2.796875 -4.828125 C 1.515625 -4.828125 0.375 -3.75 0.375 -2.34375 C 0.375 -0.953125 1.4375 0.125 2.6875 0.125 C 3.375 0.125 3.875 -0.25 4.140625 -0.59375 Z M 4.140625 -3.515625 L 4.140625 -1.28125 C 4.140625 -1.09375 4.140625 -1.0625 4.03125 -0.890625 C 3.703125 -0.359375 3.203125 -0.125 2.734375 -0.125 C 2.25 -0.125 1.859375 -0.40625 1.59375 -0.8125 C 1.3125 -1.265625 1.28125 -1.890625 1.28125 -2.328125 C 1.28125 -2.734375 1.296875 -3.390625 1.609375 -3.875 C 1.84375 -4.21875 2.25 -4.578125 2.84375 -4.578125 C 3.234375 -4.578125 3.6875 -4.421875 4.03125 -3.921875 C 4.140625 -3.734375 4.140625 -3.71875 4.140625 -3.515625 Z M 4.140625 -3.515625 "
  })))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-1",
    x: 6.395,
    y: 18.406
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-2",
    x: 81.78,
    y: 18.406
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-1",
    x: 4.843,
    y: 62.262
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-1",
    x: 12.722,
    y: 58.303
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph1-1",
    x: 79.659,
    y: 62.262
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph2-1",
    x: 87.538,
    y: 58.303
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -28.625 21.926344 L 27.203125 21.926344 ",
    transform: "matrix(1,0,0,-1,48.75,37.399)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 77.945312 15.472656 L 74.757812 13.878906 L 75.953125 15.472656 L 74.757812 17.066406 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use7 || (_use7 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 30.907,
    y: 9.514
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use8 || (_use8 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph3-1",
    x: 40.828,
    y: 9.514
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use9 || (_use9 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 48.707,
    y: 9.514
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use10 || (_use10 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph4-1",
    x: 55.843,
    y: 5.556
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use11 || (_use11 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph5-1",
    x: 62.43,
    y: 5.556
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -37.410156 -13.983812 L -37.410156 11.988844 ",
    transform: "matrix(1,0,0,-1,48.75,37.399)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 11.339844 23.417969 L 9.746094 26.605469 L 11.339844 25.410156 L 12.933594 26.605469 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use12 || (_use12 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-4",
    x: 0.371,
    y: 38.686
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M -27.074219 -21.929125 L 25.082031 -21.929125 ",
    transform: "matrix(1,0,0,-1,48.75,37.399)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 75.824219 59.328125 L 72.636719 57.734375 L 73.832031 59.328125 L 72.636719 60.921875 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use13 || (_use13 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-1",
    x: 43.75,
    y: 70.737
  })), _use14 || (_use14 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph6-2",
    x: 47.689276,
    y: 70.737
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      strokeWidth: 0.3985,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      stroke: "rgb(0%,0%,0%)",
      strokeOpacity: 1,
      strokeMiterlimit: 10
    },
    d: "M 37.410156 -13.983812 L 37.410156 11.988844 ",
    transform: "matrix(1,0,0,-1,48.75,37.399)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 86.160156 23.417969 L 84.566406 26.605469 L 86.160156 25.410156 L 87.753906 26.605469 "
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    }
  }, _use15 || (_use15 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#glyph0-3",
    x: 89.994,
    y: 40.126
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg5);
export default __webpack_public_path__ + "static/media/svg5.c29c748630bdae76d24d3331d5d769c1.svg";
export { ForwardRef as ReactComponent };